import React, { Component } from "react";
import ExportToExcel from "../../SExport/ExportToExcle";
import moment from "moment";
import {
  Button,
  // Input,
  Label,
  InputGroupAddon,
  Col,
  InputGroupText,
  Row,
} from "reactstrap";
import "./baseForms.css";
import "./formsTable.css";
import DatePicker from "react-datepicker";
import Swal from "sweetalert2";
import Select from "react-select";
import axios from "axios";
import { baseurl } from "../../../../baseurl";
import { supplierMatchesBranch } from "../../../../utils/functions";
import { generateCriteriaString } from "./../../ShortFunction/shortFunctions";
import { check_Bussiness_Permission } from "../../../../Helper";

import { Link } from "react-router-dom";

import swal from "@sweetalert/with-react";
import "./myReactSelect.css";
import "../../../../index.css";
import "react-datepicker/dist/react-datepicker.css";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { checkPermission } from "../../../../Helper";
var thisContex;
var token = localStorage.getItem("token");
var username = localStorage.getItem("username");
var token = localStorage.getItem("token");
var companyId = localStorage.getItem("companyId");
// var companySymbolCurrency = localStorage.getItem("companySymbolCurrency");
var companySymbolCurrency = "";

const listOfColKey = [
  { align: "left", value: "invoiceDate" },
  { align: "right", value: "DocumcentNo" },
  { align: "left", value: "INVOICE_REF_NO" },
  { align: "right", value: "payments" },
  { align: "right", value: "invoiceAmount" },
  { align: "right", value: "total" },
];

const listOfColLables = [
  { align: "left", value: "Date" },
  { align: "left", value: "Doc No" },
  { align: "left", value: "Activity" },
  { align: "center", value: "Payment" },
  { align: "center", value: "Invoice Amount" },
  { align: "center", value: "Balance" },
];
function due_Formators(cell, row, enumObject, index) {
  let newCell = "";
  newCell = cell;
  if (typeof cell === "string") {
    newCell = parseFloat(cell);
  }

  if (newCell) {
    newCell = newCell?.toLocaleString("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });

    // newCell = companySymbolCurrency + " " + newCell;
  } else {
    newCell = "-";
  }
  return newCell;
}
function dueFormatorsTotal(cell, row, enumObject, index) {
  let newCell = "";
  let runingBalanceActualy = 0;
  if (cell) {
    newCell = parseFloat(cell);

    //runningBalance=Math.abs(runningBalance);
    if (newCell > 0) {
      runingBalanceActualy = Math.abs(newCell);
      runingBalanceActualy = runingBalanceActualy?.toLocaleString("en-US", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });

      runingBalanceActualy =
        companySymbolCurrency + " " + runingBalanceActualy + " " + "Dr";
    } else {
      runingBalanceActualy = Math.abs(newCell);
      runingBalanceActualy = runingBalanceActualy?.toLocaleString("en-US", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });

      runingBalanceActualy =
        companySymbolCurrency + " " + runingBalanceActualy + " " + "Cr";
    }
  }
  if (
    (row?.INVOICE_TYPE === 7 && row?.CrdtNoteApp !== "apply") ||
    (row?.INVOICE_TYPE === 14 && row?.CrdtNoteApp !== "apply")
  ) {
    return <div style={{ color: "red" }}>{runingBalanceActualy}</div>;
  } else {
    return <div>{runingBalanceActualy}</div>;
  }
}

function dueFormatorsPayment(cell, row, enumObject, index) {
  let newCell = "";

  if (cell) {
    newCell = cell?.toLocaleString("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  }

  if (cell !== "" && cell !== 0 && cell !== null) {
    newCell = companySymbolCurrency + " " + newCell;
    return <div>{newCell}</div>;
  }
}
function dueFormatorsWithoutDiv(cell, row, enumObject, index) {
  let newCell = "";
  let runingBalanceActualy = 0;
  if (cell) {
    newCell = parseFloat(cell);

    //runningBalance=Math.abs(runningBalance);
    if (newCell > 0) {
      runingBalanceActualy = Math.abs(newCell);
      runingBalanceActualy = runingBalanceActualy?.toLocaleString("en-US", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });

      runingBalanceActualy =
        companySymbolCurrency + " " + runingBalanceActualy + " " + "Dr";
    } else {
      runingBalanceActualy = Math.abs(newCell);
      let runingBalanceActualyNum = Number(runingBalanceActualy);

      if (isNaN(runingBalanceActualyNum)) {
        runingBalanceActualy = "0.00"; // ya jo default value chahiye ho
      } else {
        runingBalanceActualy = runingBalanceActualyNum.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }

      runingBalanceActualy =
        companySymbolCurrency + " " + runingBalanceActualy + " " + "Cr";
    }
  }
  return runingBalanceActualy;
}
function dueFormators(cell, row, enumObject, index) {
  let newCell = "";

  if (cell) {
    newCell = cell?.toLocaleString("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  }

  if (cell !== "" && cell !== 0 && cell !== null) {
    newCell = companySymbolCurrency + " " + newCell;

    if (
      (row.INVOICE_TYPE === 7 && row.CrdtNoteApp !== "apply") ||
      (row.INVOICE_TYPE === 14 && row.CrdtNoteApp !== "apply")
    ) {
      return <div style={{ color: "red" }}>{newCell}</div>;
    } else {
      return <div>{newCell}</div>;
    }
  }
}
function calculateDaysLeft(startDatee, endDatee) {
  if (!moment.isMoment(startDatee)) startDatee = moment(startDatee);
  if (!moment.isMoment(endDatee)) endDatee = moment(endDatee);

  var res = endDatee.diff(startDatee, "days");
  return res;
}

class SupplierStatement extends Component {
  constructor(props) {
    super(props);
    thisContex = this;

    let tempLogedIn = false;
    let defaultdate = new Date();
    defaultdate = moment(defaultdate).format("YYYY-MM-DD");
    //////////////------------Token for Login prepose True and False Condition----------///////////////////////
    if (token != null) {
      tempLogedIn = true;
    }

    //////////////-------Components this States here to use in only Class Components ------///////////////////////
    this.state = {
      activeTab: new Array(6).fill("1"),
      logInStatus: tempLogedIn,
      divcontainer: false,
      balance: "",

      totalBalance: "",
      loadingFindButton: false,
      customerName: "",
      customerEmail: "",
      defaultdate: defaultdate,
      clientLov: "",
      branchSupplierLov: [],
      spanTextDate: "",
      redirect: false,
      criteriaString: "All",

      redirectSomeOnePaid: false,
      redirectToCreativeInvoice: false,
    };
  }
  setDelete = (row) => {
    let id = row.INVOICE_ID;

    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      size: "md",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(
            `${baseurl}/masterData/deleteInvoiceOverViewID`,
            { id: id, username: username },

            {
              headers: {
                authorization: token,
              },
            }
          )
          .then((response) => {
            Swal.fire("Deleted!", "Your Record has been deleted.", "success");
            thisContex.getOverviewData();
          })
          .catch((err) => {
            console.log(err);
            swal({
              title: "Failed!",
              text: "Internet Problem",
              icon: "error",
              size: "md",
              button: "Try Again!",
            });
          });
      }
    });
  };
  handleChangeLovsSelect = (customer_id) => {
    this.setState({
      customer_id,
      customerName: customer_id?.label,
    });

    // this.getSupplierStatement(
    //   customer_id?.id,
    //   this.state.startDate,
    //   this.state.endDate
    // );
  };
  handleToChangeOpen = (branch) => {
    let result = [];

    result = this.state.clientLov.filter(
      (item) => supplierMatchesBranch(item, branch)
    );
    console.log("result==>>", branch, this.state.clientLov, result);
    this.setState({
      branch,
      branchSupplierLov: result,
      customer_id: null,
    });
  };
  validateNumber = (value, defaultValue = 0) => {
    if (typeof value === "number" && !isNaN(value) && value !== 0) {
      return value;
    }
    return defaultValue;
  };
  funPrintView = (data1, headers, headerKeyMap, allData) => {
    let fromDate = allData.fromDate
      ? moment(allData.fromDate).format("DD-MMM-YYYY")
      : "All";
    let toDate = allData.toDate
      ? moment(allData.toDate).format("DD-MMM-YYYY")
      : "All";

    this.props.history.push({
      pathname: "/PrintReports",
      state: {
        data: data1,
        headers: headers,
        headerKeyMap: headerKeyMap,
        goBackUrl: "/SupplierStatement",
        dynamicInvMessage: "Supplier Statement Report",
        reportName: "Supplier Statement Report",
        criteriaString: this.state?.criteriaString,
      },
    });
  };

  async getSupplierStatement(supplierId, startDate, endDate) {
    var balance = 0;
    let docArray = [];
    let docSuppPayArray = [];
    // 1st call for Load data in Data table. We are on the main page.
    let isLoadedName = this.props.location.state?.idFromClientOverview;
    let companyId = localStorage.getItem("companyId");

    await axios
      .post(
        `${baseurl}/repots/getMultiplePurchaseDocNo`,
        {
          companyId: companyId,
          supplierId: supplierId,
          username: username,
          startDate: startDate,
          endDate: endDate,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(function (response) {
        let res = response.data.data;

        let duplicatePaymentNo;
        let docNo;
        let purchaseInvoiceDocNo;
        console.log("checkkkkkk", res);
        for (var i = 0; i < res.length; i++) {
          if (res[i]["payment_id"] === res[i + 1]?.payment_id) {
            duplicatePaymentNo = res[i]["payment_id"];
            docNo = `${res[i]["payment_no"]}, ${res[i + 1]?.payment_no}`;
            docArray.push({
              docNo: docNo,
              receiptId: res[i]["payment_id"],
            });
          }
          if (res[i]["payment_id"] !== res[i + 1]?.payment_id) {
            purchaseInvoiceDocNo = res[i]["payment_no"];
            docSuppPayArray.push({
              docNo: purchaseInvoiceDocNo,
              receiptId: res[i]["payment_id"],
            });
          }

          console.log(docArray);
        }
      })
      .catch(function (error) {
        console.log(error);
      });

    await axios
      .post(
        `${baseurl}/repots/getSupplierStatement`,
        {
          idFromClientOverview: isLoadedName,
          companyId: companyId,
          supplierId: supplierId,
          branch: this.state.branch?.id,
          startDate: startDate,
          username: username,
          endDate: endDate,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )

      .then(function (response) {
        // let todayDate = new Date();
        let newArr = [];
        let printData = [];
        let sumBalance = 0;
        // todayDate = moment(todayDate).format("YYYY-MM-DD");
        let callData = response.data.data;
        let openingBalanceData = response.data.data2;
        let openingRunningBalance = 0;
        if (openingBalanceData !== undefined) {
          if (openingBalanceData.length > 0) {
            for (var j = 0; j < openingBalanceData.length; j++) {
              // if(openingBalanceData[j]["Debit"]!==0)
              // {
              openingRunningBalance += +openingBalanceData[j]["Debit"];
              // }
              // else
              // {
              //   openingRunningBalance = openingRunningBalance - openingBalanceData[j]["Credit"];
              // }
              sumBalance += +openingRunningBalance;
            }
            newArr.push({
              invoiceDate: "",
              INVOICE_REF_NO: "Opening Balance",
              invoiceDueDate: "",
              invoiceAmount: "",
              payments: "",
              total: openingRunningBalance,
            });
          } else {
            newArr.push({
              invoiceDate: "",
              INVOICE_REF_NO: "Opening Balance",
              invoiceDueDate: "",
              invoiceAmount: "",
              payments: "",
              total: "",
            });
          }
        }
        let indexIncreament = 0;
        let indexReceiptIncreament = 0;
        // var invoiceAmount;
        if (openingRunningBalance !== 0 && openingRunningBalance !== "") {
          sumBalance = openingRunningBalance;
        }

        let totalBalance = 0;
        let len = callData.length;
        let Activity;
        let docNo;
        for (var i = 0; i < len; i++) {
          if (callData[i]["total_un_applied_amount"] !== 0) {
            sumBalance += +callData[i]["total_un_applied_amount"];
          } else {
            sumBalance = sumBalance - callData[i]["Credit"];
          }
          if (callData[i]["INV_BOOK_ID"] === 6) {
            Activity = "Purchase";
            docNo = callData[i]["Activity"];
          }
          if (callData[i]["INV_BOOK_ID"] === 7) {
            Activity = "Unapplied Credit Note";
            docNo = callData[i]["Activity"];
          }
          if (callData[i]["INV_BOOK_ID"] === 14) {
            Activity =
              "Refund apply on purch No" + " " + callData[i]["appliedDoc"];
            docNo = callData[i]["Activity"];
          }
          if (callData[i]["Activity"] === "apply") {
            Activity =
              "Credit Note Applied on purch No " +
              " " +
              callData[i]["appliedDoc"];

            docNo = callData[i]["INV_BOOK_ID"];
          }
          if (callData[i]["INV_BOOK_ID"] === 24) {
            if (docArray !== undefined) {
              if (
                callData[i]["purchaseId"] ===
                docArray[indexIncreament]?.receiptId
              ) {
                Activity =
                  "Supplier Payment of purchase no(s)" +
                  " " +
                  docArray[indexIncreament]?.docNo;
              }
            }
            if (docSuppPayArray !== undefined) {
              if (
                callData[i]["purchaseId"] !==
                docArray[indexIncreament]?.receiptId
              ) {
                Activity =
                  "Supplier Payment of purchase no(s)" +
                  " " +
                  docSuppPayArray[indexReceiptIncreament]?.docNo;
              }
              if (docSuppPayArray.length - 1 > indexReceiptIncreament) {
                indexReceiptIncreament++;
              }
            }
            if (docArray !== undefined) {
              if (docArray.length - 1 > indexIncreament) {
                indexIncreament++;
              }
            }
            docNo = callData[i]["Activity"];
          }
          if (
            (callData[i]["Credit"] !== 0 && callData[i]["Credit"] !== "") ||
            (callData[i]["total_un_applied_amount"] !== 0 &&
              callData[i]["total_un_applied_amount"] !== "")
          ) {
            newArr.push({
              invoiceDate: callData[i]["date"],
              INVOICE_REF_NO: Activity,
              invoiceDueDate: "",
              invoiceAmount: callData[i]["Credit"],
              payments: callData[i]["total_un_applied_amount"],
              total: sumBalance,
              DocumcentNo: docNo,
              INVOICE_TYPE: callData[i]["INV_BOOK_ID"],
              CrdtNoteApp: callData[i]["Activity"],
              // payments: callData[i]["total_un_applied_amount"],
            });
          }
        }
        let neArr = [];

        let len2 = newArr.length;
        if (newArr && newArr.length > 0) {
          totalBalance = newArr[len2 - 1]["total"];
        } else {
          console.log("newArr empty hai");
        }
        console.log(newArr);
        console.log("*****=====*********", newArr);

        let objblank = {
          invoiceDate: "",
          INVOICE_REF_NO: "",
          invoiceDueDate: "",
          invoiceAmount: " ",
          payments: "",
          total: "",
        };
        let objTableName = {
          invoiceDate: "Account Statement Report",
          INVOICE_REF_NO: "",
          invoiceDueDate: "",
          invoiceAmount: " ",
          payments: "",
          total: "",
        };
        let objTableHeader = {
          invoiceDate: " Date",
          INVOICE_REF_NO: "Activity",
          invoiceDueDate: " Due Date",
          invoiceAmount: "Invoice Amount ",
          payments: " Payment",
          total: " Balance",
        };

        neArr.push(objTableName, objTableHeader);
        for (let index = 0; index < newArr.length; index++) {
          neArr.push(newArr[index]);
          let element = newArr[index];
          printData.push({
            invoiceDate: element.invoiceDate,
            DocumcentNo: element.DocumcentNo,
            INVOICE_REF_NO: element.INVOICE_REF_NO,
            payments: due_Formators(element.payments),
            invoiceAmount: due_Formators(element.invoiceAmount),
            total: dueFormatorsWithoutDiv(element.total),
            // dueFormatorsTotal
          });
        }
        neArr.push(objblank);
        console.log(neArr);
        console.log("*******************", newArr);
        if (newArr && newArr.length > 0) {
          sumBalance = neArr[len2 - 1]["total"];
        } else {
          console.log("newArr empty hai");
        }
        console.log(sumBalance);
        let objCrDr = {
          invoiceDate: "Total",
          INVOICE_REF_NO: "",
          invoiceDueDate: "",
          invoiceAmount: " ",
          payments: "",
          total: sumBalance,
        };
        neArr.push(objCrDr);
        neArr.push(objCrDr);
        printData.push({
          invoiceDate: "Total",
          // invoiceDate: "",
          DocumcentNo: "",
          INVOICE_REF_NO: "",
          payments: "",
          invoiceAmount: "",
          total: dueFormatorsWithoutDiv(totalBalance),
        });
        thisContex.setState({
          OverViewDataTable: newArr,
          totalBalance: totalBalance.toFixed(4),
          newArr: neArr,
          printData: printData,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  redirectToOrder = (cell, row) => {
    if (row.t === "INV" && cell === "someOnePaid") {
      this.setState({
        redirectSomeOnePaid: true,
        idd: row.CUSTOMER_ID,
        propInvoiceId: row.INVOICE_ID,
      });
    } else if (row.t === "RET" && cell === "someOnePaid") {
      this.setState({
        redirectCreditNoteApp: true,
        propsCustomerId: row.CUSTOMER_ID,
        propsDue: row.due,
        propsIssuedDate: row.issued_date,
        propsName: row.name,
        propsRefNo: row.no,
        propsPaid: row.creditNoteAmount,
      });
    } else if (cell === "update") {
      this.setState({
        redirect: true,
        id: row.INVOICE_ID,
        updateCheck: 0,
      });
    }

    if ((row.paid > 0 && cell === "view") || row.Paid === "Paid") {
      this.setState({
        redirectToCreativeInvoice: true,
        id: row.INVOICE_ID,
        updateCheck: 1,
      });
    } else if (row.paid === 0 && cell === "view") {
      this.setState({
        redirectToCreativeInvoice: true,
        id: row.INVOICE_ID,
        updateCheck: 0,
      });
    }
  };

  statusFormator = (cell, row, enumObject, index) => {
    let today = thisContex.state.defaultdate;
    let daysLeft = calculateDaysLeft(today, cell);
    if (cell !== "Invalid date" && row.due > 0) {
      return (
        <div>
          {cell !== "Invalid date" && daysLeft > 0 ? (
            <span className="mr-1 badge badge-warning">
              {daysLeft} days left
            </span>
          ) : (
            <span className="mr-1 badge badge-danger">
              {Math.abs(daysLeft)} days over{" "}
            </span>
          )}

          {row.paid === 0 ? (
            <>
              <span>
                <Button
                  style={{ margin: "3px" }}
                  type="submit"
                  size="sm"
                  color="success"
                  onClick={() => {
                    this.redirectToOrder("update", row);
                  }}
                >
                  Update
                </Button>
              </span>
              <span>
                <Button
                  style={{ margin: "3px" }}
                  type="submit"
                  size="sm"
                  color="danger"
                  onClick={() => this.setDelete(row)}
                >
                  Delete
                </Button>
              </span>
            </>
          ) : null}
          {row.due !== 0 && row.PostedYN === 1 ? (
            <Button
              // type="cancel"
              color="primary"
              className="mr-1"
              size="sm"
              onClick={() => {
                this.redirectToOrder("someOnePaid", row);
              }}
            >
              <i className="fa fa-euro"></i>
              <i className="fa fa-euro"></i>
            </Button>
          ) : null}

          <Button
            className="mr-1"
            size="sm"
            onClick={() => {
              this.redirectToOrder("view", row);
            }}
          >
            <i className="fa fa-eye"></i>
          </Button>
        </div>
      );
    } else if (row.due === 0) {
      return (
        <>
          <span>
            <Button className="mr-1" size="sm">
              Paid
            </Button>
          </span>
          <span>
            <Button
              className="mr-1"
              size="sm"
              onClick={() => {
                this.redirectToOrder(cell, row);
              }}
            >
              <i className="fa fa-eye"></i>
            </Button>
          </span>
        </>
      );
    }
  };
  ////////////////////////////-----END------////////////////////////////////

  async componentDidMount() {
    await this.checkBussinessPermission();
    await this.asyncRollCheck(0);
    this.getSuppliers();
    this.getBranchLov();
  }
  asyncRollCheck = async (value) => {
    let pathname = "/SupplierStatement";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission && value === 3) {
      return true;
    }
  };
async checkBussinessPermission() {
    let checkBussinessPermission = await check_Bussiness_Permission();
    console.log("checkBussinessPermission :>> ", checkBussinessPermission);
    let { business_type_id, isCrumble, isAgh, isDollarjnction, isEggSpectation } =
      checkBussinessPermission;
    
    if (isEggSpectation) {
      this.setState({
        isEggSpectation,
      });
    }
  }
  getSuppliers() {
    axios
      .post(
        `${baseurl}/lovs/getSuppliers`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(function (response) {
        let mydata = [];

        let responseData = response.data.data;
        for (let loop = 0; loop < responseData.length; loop++) {
          mydata.push({
            id: responseData[loop]["SUPPLIER_ID"],
            value: responseData[loop]["SUPPLIER_ID"],
            label: responseData[loop]["COMPANY_NAME"],
            supp_categ_id: responseData[loop]["supp_categ_id"],
          });
        }

        thisContex.setState({
          clientLov: mydata,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  ////////////////------End-----////////////////////
  onChangeHandler = (e) => {
    thisContex.setState({
      [e.target.name]: e.target.value,
    });
  };
  handleChangeStartDate = (e) => {
    thisContex.setState({
      startDate: e,
    });
  };
  getBranchLov = () => {
    axios
      .post(
        `${baseurl}/lovs/getDynamicBranchLov`,

        {
          companyId: companyId,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(function (response) {
        let responseData = response.data.data;
        const allObj = {
          id: null,
          value: null,
          label: "All",
        };
        // Insert at first index
        responseData.unshift(allObj);
        thisContex.setState({
          branchLov: responseData,
        });
      })
      .catch(function (error) {
        swal({
          title: "Error",
          text: "Something went wrong, try to refresh the page and try again.",
          icon: "error",
        });
        console.log(error);
      });
  };
  handleChangeEndDate = (e) => {
    var startDate = moment(thisContex.state.startDate).format("YYYY-MM-DD");
    var endDate = moment(e).format("YYYY-MM-DD");
    if (startDate <= endDate) {
      thisContex.setState({
        endDate: e,
        spanTextDate: "",
      });
    } else {
      thisContex.setState({
        //endDate: " " ,
        spanTextDate: "To date is greater than or equal to From date",
      });
    }
  };
  async loadingFindButtonToggle() {
    this.setState({
      loadingFindButton: !this.state.loadingFindButton,
    });
  }
  findBtn = async (e) => {
    e.preventDefault();
    await this.loadingFindButtonToggle();
    // console.log(this.state.customer_id);
    // console.log(thisContex.state.startDate);
    // console.log(thisContex.state.endDate);
    // return;
    if (
      thisContex.state.startDate !== undefined &&
      thisContex.state.endDate !== undefined &&
      thisContex.state.customer_id &&
      thisContex.state.branch
    ) {
      var supplierId = this.state.customer_id?.id;
      var startDate = moment(new Date(thisContex.state.startDate)).format(
        "YYYY-MM-DD"
      );
      var endDate = moment(new Date(thisContex.state.endDate)).format(
        "YYYY-MM-DD"
      );

      console.log("supplierId", supplierId);
      const critObj = {
        fromDate: startDate,
        toDate: endDate,
        supplier_id: supplierId,
        multiSuppLabel: this.state.customer_id?.label,
        multiPosBranchLabel: this.state.branch?.label,
        multiPosBranch: this.state.branch?.id,
        branch_id: this.state.branch,
      };
      const criteriaString = generateCriteriaString(critObj);
      this.setState({
        criteriaString: criteriaString,
      });
      console.log("criteriaString :>> ", criteriaString);

      await this.getSupplierStatement(supplierId, startDate, endDate);
      await this.loadingFindButtonToggle();
    } else {
      await this.loadingFindButtonToggle();
      swal({
        title: "Complete Criteria required!",
        text: "Please select  Branch & Supplier, From-Date and To-Date and then find again",
        icon: "warning",
      });
    }
  };
  render() {
    const { OverViewDataTable, newArr, loadingFindButton, isEggSpectation } = this.state;
    const options = {
      paginationShowsTotal: true,
      page: 1,
      sizePerPage: 15,
      pageStartIndex: 1,
      paginationSize: 3,
      prePage: "Prev",
      nextPage: "Next",
      firstPage: "First",
      lastPage: "Last",
      prePageTitle: "Go to previous",
      nextPageTitle: "Go to next",
      firstPageTitle: "Go to first",
      lastPageTitle: "Go to Last",
      paginationPosition: "top",
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "20",
          value: 20,
        },
        {
          text: "30",
          value: 30,
        },
        {
          text: "All",
          value: OverViewDataTable?.length,
        },
      ],
    };
    return (
      <div className="animated fadeIn">
        <Row className="Creative-Invoice-header-styling">
          <Col xs="6" className="card-header-Creative-Invoice">
            <h4>Supplier Statement</h4>
          </Col>
          <Col xs="6" className="card-header-Creative-Invoice">
            <div
              style={{
                textAlign: "right",
              }}
            >
              <Link
                to={{
                  pathname: "/AddSuppliers",
                }}
                title={"Suppliers Overview"}
                style={{
                  fontFamily: "Times New Roman",
                  fontWeight: "normal",
                  margin: "10px",
                }}
              >
                <u className="Back-to-Overview">Back to Overview</u>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-chevron-left mx-2 icon-color"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                  />
                </svg>
              </Link>
            </div>
          </Col>
        </Row>
        <br></br>
        <Row className="rowStyling">
          <Col>
            <div className="row">
              <div className="col-md-5">
                <Select
                  value={this.state.branch}
                  onChange={this.handleToChangeOpen}
                  options={this.state.branchLov}
                  autoFocus
                  required
                  name="selectedOptionPhase"
                  placeholder={"Select Branch"}
                  isDisabled={this.state.disabled ? true : false}
                />
              </div>
              <div className="col-md-5">
                <Select
                  value={this.state.customer_id}
                  onChange={this.handleChangeLovsSelect}
                  // options={this.state.clientLov}
                  // options={this.state.branchSupplierLov}
                  options={isEggSpectation ? this.state.branchSupplierLov : this.state.clientLov}
                  autoFocus
                  required
                  name="selectedOptionPhase"
                  placeholder={"Select Supplier"}
                  isDisabled={
                    this.state.disabled || (!this.state.branch?.id && isEggSpectation) ? true : false
                  }
                />
              </div>
              <div className="col-md-2">
                <h5>( All Amounts are PKR! )</h5>
              </div>
            </div>
            <br></br>
            <div className="row">
              <div className="col-md-3">
                <Label style={{ fontWeight: "bold" }}>
                  From Date:
                  <h8 style={{ color: "tomato" }}>*</h8>
                </Label>
                <div className=" d-flex flex-row">
                  <DatePicker
                    className="form-control"
                    id="startDate"
                    name="startDate"
                    placeholderText="dd-mm-yyyy"
                    dateFormat="dd-MM-yyyy"
                    selected={thisContex.state.startDate}
                    required
                    value={thisContex.state.startDate}
                    // min={moment(new Date()).format("YYYY-MM-DD")}
                    onChange={(e) => {
                      this.handleChangeStartDate(e);
                    }}
                  />
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText className="calended_icon">
                      <i class="fa fa-calendar-plus-o" aria-hidden="true" />
                    </InputGroupText>
                  </InputGroupAddon>
                </div>
              </div>
              <div className="col-md-3">
                <Label style={{ fontWeight: "bold" }}>
                  To Date:
                  <h8 style={{ color: "tomato" }}>*</h8>
                </Label>
                <div className=" d-flex flex-row">
                  <DatePicker
                    className="form-control"
                    id="endDate"
                    name="endDate"
                    placeholderText="dd-mm-yyyy"
                    dateFormat="dd-MM-yyyy"
                    selected={thisContex.state.endDate}
                    required
                    value={thisContex.state.endDate}
                    // min={moment(new Date()).format("YYYY-MM-DD")}
                    onChange={(e) => {
                      this.handleChangeEndDate(e);
                    }}
                  />
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText className="calended_icon">
                      <i class="fa fa-calendar-plus-o" aria-hidden="true" />
                    </InputGroupText>
                  </InputGroupAddon>
                </div>
                <span>{thisContex.state.spanTextDate}</span>
              </div>
              <div className="col-md-1">
                <Button
                  // type="submit"
                  size="md"
                  color="warning"
                  className="mr-1"
                  onClick={this.findBtn}
                  style={{ marginTop: "30px" }}
                  disabled={loadingFindButton}
                >
                  {loadingFindButton ? (
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : (
                    "Find"
                  )}
                </Button>
              </div>
              <div className="col-md-2" style={{ paddingTop: "29px" }}>
                {newArr?.length > 0 ? (
                  <ExportToExcel
                    Data={newArr}
                    criteriaString={this.state?.criteriaString}
                  />
                ) : null}
              </div>
              <div className="col-md-2" style={{ paddingTop: "29px" }}>
                {newArr?.length > 0 && (
                  <Button
                    color="success"
                    className="ml-2"
                    onClick={() =>
                      this.funPrintView(
                        this.state.printData,
                        listOfColLables,
                        listOfColKey,
                        {
                          fromDate: this.state.startDate,
                          toDate: this.state.endDate,
                          customerName: this.state.customerName,
                        }
                      )
                    }
                  >
                    Print
                  </Button>
                )}
              </div>
            </div>
            <BootstrapTable
              data={OverViewDataTable}
              striped
              pagination
              hover
              search
              tableHeaderClass="rpr_header"
              tableBodyClass="rpr_body"
              containerClass="rpr_container"
              headerStyle={{
                position: "sticky",
                top: "0",
                //  zIndex: "1000"
              }}
              options={options}
            >
              <TableHeaderColumn
                dataField="invoiceDate"
                dataAlign="center"
                width="15%"
              >
                Date
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="DocumcentNo"
                dataAlign="center"
                width="10%"
              >
                Doc No
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="INVOICE_REF_NO"
                dataAlign="center"
                width="30%"
              >
                Activity
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="payments"
                dataAlign="right"
                width="15%"
                isKey={true}
                dataFormat={dueFormatorsPayment}
              >
                Payment
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="invoiceAmount"
                dataAlign="right"
                width="15%"
                dataFormat={dueFormators}
              >
                Invoice Amount
              </TableHeaderColumn>

              <TableHeaderColumn
                dataAlign="right"
                dataField="total"
                width="15%"
                dataFormat={dueFormatorsTotal}
              >
                Balance
              </TableHeaderColumn>
            </BootstrapTable>
            <div className="row">
              <div className="col-md-8">
                <h5
                  className="mt-2"
                  style={{
                    color: "red",
                    fontSize: "smaller",
                    paddingTop: "5px",
                    paddingLeft: "inherit",
                  }}
                >
                  Dr means receivable from supplier and Cr means payable to
                  supplier in this report
                </h5>
              </div>
              <div className="col-md-4">
                <div style={{ display: "flex" }}>
                  <h5
                    style={{
                      whiteSpace: "nowrap",
                      margin: "auto",
                      paddingRight: "7px",
                    }}
                  >
                    Balance
                  </h5>
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    style={{
                      textAlign: "right",
                      fontSize: "18px",
                    }}
                    value={dueFormatorsWithoutDiv(this.state.totalBalance)}
                  ></input>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
export default SupplierStatement;
